module.exports = __webpack_public_path__ + "static/media/fly0213.c01798e0.webp";